import { Injectable, OnDestroy } from '@angular/core';
import { HcService } from '@project/services';
import { BehaviorSubject } from 'rxjs';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppInitializerService implements OnDestroy {
  private initialized$ = new BehaviorSubject<boolean>(false);
  private readonly FADEOUT_DELAY = 500;

  constructor(private hcService: HcService) {}

  initialize(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const hcConfig = this.hcService.getHcConfig();

      const logo = document.querySelector('.splash__logo') as HTMLImageElement;
      if (logo && hcConfig.assets.logo) {
        logo.src = hcConfig.assets.logo;
      }

      const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
      if (favicon && hcConfig.assets.favicon) {
        favicon.href = hcConfig.assets.favicon;
      }

      this.setupGoogleAnalytics(hcConfig.config.trackingId);

      const preloader = document.getElementById('preloader');
      if (preloader) {
        preloader.classList.add('fadeout');
        setTimeout(() => {
          this.initialized$.next(true);
          resolve(true);
        }, this.FADEOUT_DELAY);
      } else {
        this.initialized$.next(true);
        resolve(true);
      }
    });
  }
  private setupGoogleAnalytics(trackingId: string): void {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', trackingId);
  }

  ngOnDestroy() {
    this.initialized$.complete();
  }
}
